export default __webpack_public_path__ + "static/media/stop_assign.3ec76ecc.svg";